
// © 2001-2015 INOVx Solutions, Inc.
// 114 Pacifica Suite 300, Irvine, CA 92618 USA
// All rights reserved.
//
// This software is confidential, proprietary and unpublished property of
// INOVx Solutions, Inc.  It may NOT be copied in part or in whole on any
// medium, either electronic or printed, without the express written consent
// of INOVx Solutions, Inc.

export enum MemoryMode {
    DEFAULT = 0,
    MAXIMUM = 1
}
export enum PickMode {
    SELECT = 0,
    FOCUS = 1,
    MP = 2,
    MEASUREMENT = 3,
    POINT3D = 4
}
export enum ViewerFillStyle {
    FIT = 1,
    FILL = 2
}
export enum CameraMode {
    PERSPECTIVE = 0,
    ORTHOGRAPHIC = 1
}

export enum SelectMode {
    SINGLE = 0,
    ALL = 1,
    RANDOM = 2
}
export enum ClickMode {
    NAVIGATE = 0,
    REGION = 1
}

export enum DisplayChunkResult {
    DISPLAYFINISHED = 0,
    MORETODISPLAY = 1,
    NONETODISPLAY = 2
}

export enum CameraNavigationMode {
    Examine,
    Pan,
    Walk,
    Universal,
    Fly
}

export enum AnnotationLabelShape {
    RECTANGLE = 0,
    TRIANGLE = 1,
    PENTAGON = 2,
    HEXAGON = 3,
    ELLIPSE = 4,
    CIRCLE = 5,
    DIAMOND = 6,
    BANNER = 7,
    PARALL = 8,
    TRAPEZ = 9,
    CLOUD = 10,
    ARROW = 11
}

export enum MarkedPointPrimitiveShape {
    SPHERE
}

export enum EventType {
    SELECTIONCHANGED,
    SELECTIONMODECHANGED,
    DISPLAYFINISHED,
    DISPLAYMEMORYLIMIT,
    CAMERAFOCUSED,
    CAMERABOXZOOMED,
    CAMERACHANGED,
    SCANPOSITIONHIGHLIGHTED,
    SCANPOSITIONRIGHTCLICKED,
    VOLUME_TAG_CHANGED,
    FOVCHANGED,
    CAMERAMODECHANGED,
    MEASUREMENTCREATED,
    MEASUREMENTSCLEARED,
    STARTBLOCKINGOPERATION,
    ENDBLOCKINGOPERATION,
    POINT3DCLICKED,
    ASSEMBLYCREATED,
    ASSEMBLYUPDATED,
    SETTINGCHANGED
}

export enum MaterialEdgeMode {
    SOLID,
    WIREFRAME
}

export enum ToolbarCommandType {
    XRay = 'xray-mode',
    PointXRay = 'point-xray-toggle',
    Collision = 'point-collision-toggle',
}

export enum PointShadeMode {
    SPLAT = "SPLAT",
    XRAY = "XRAY",
    COLLISION = "COLLISION"
}

export enum MeshShadeMode {
    DEFAULT = "DEFAULT",
    XRAY = "XRAY"
}


export enum ViewerSettingType {
    MESHDISPLAYMODE = "MESHDISPLAYMODE",
    POINTDISPLAYMODE = "POINTDISPLAYMODE"
}

export enum BackgroundSceneType {
    COLOR = 1,
    DAYLIGHT = 2,
    NIGHTTIME = 3,
    DUSK = 4,
    DAWN = 5,
    DESERT = 6,
    OFFSHORE = 7
}

export enum PickObjectType {
    Unknown = "unknown",
    Object = "object",
    GLBObject = "glbobject",
    Mesh = "mesh",
    PagedMesh = "pagedmesh",
    Scan = "scan",
    Annotation = "annotation",
    Assembly = "assembly",
    ScanPos = "scanpos",
}

export enum WaypointType {
    JUNCTION = 1,
    PATH = 2
}

export type LightingMode = "ambient" | "headlight";
